// @flow

import apiRequest from './apiRequest'

export const get = apiRequest('get')
export const post = apiRequest('post')
export const put = apiRequest('put')
